<app-maintenance-banner></app-maintenance-banner>
<router-outlet></router-outlet>
<app-spinner></app-spinner>
